import {
    $, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';
import { BREAKPOINTS } from '../shared/theme-globals';

addAction(INIT, () => {
    const $subNav = $('.nav-menu--dynamic');
    const $subNavItems = $subNav.find('.nav-menu__item');
    const $subNavItem = $subNavItems.first();
    const $pageTitleBlock = $('.page-header__content').find('.block-title__block').last();
    const $parent = $subNav.parents('.page-header__nav-menu');
    if (!$subNav.length) {
        return;
    }

    function navClassModifier(modifier) {
        return `nav-menu--${modifier}`;
    }

    function headerClassModifier(modifier) {
        return `page-header__nav-menu--${modifier}`;
    }

    function navWidth() {
        let width = 0;
        $subNavItems.each((i, el) => {
            width += $(el).outerWidth(true);
        });
        return width;
    }

    function getPositions($elem, pad) {
        const pos = $elem.offset();
        const width = $elem.width();
        const height = $elem.height();
        return [
            [pos.left - pad, pos.left + width + pad],
            [pos.top, pos.top + height],
        ];
    }

    function comparePositions(p1, p2) {
        const r1 = p1[0] < p2[0] ? p1 : p2;
        const r2 = p1[0] < p2[0] ? p2 : p1;
        return r1[1] > r2[0] || r1[0] === r2[0];
    }

    function overlaps(a, b, pad) {
        const pos1 = getPositions(a, pad);
        const pos2 = getPositions(b, pad);
        return comparePositions(pos1[0], pos2[0]) && comparePositions(pos1[1], pos2[1]);
    }

    function reset() {
        $subNav.removeClass(navClassModifier('dropdown')).addClass(navClassModifier('horizontal'));
        $parent.addClass(headerClassModifier('inside')).removeClass(headerClassModifier('outside'));
    }

    function moveOutside() {
        $parent.addClass(headerClassModifier('outside')).removeClass(headerClassModifier('inside'));
    }

    function toggleClass(update) {
        if (!update) {
            return;
        }

        const viewportWidth = SetDesign.viewport.width();
        reset();

        if (overlaps($pageTitleBlock, $subNavItem, 10)) {
            moveOutside();
        }
        if (viewportWidth < BREAKPOINTS.sm || navWidth() > $subNav.width()) {
            moveOutside();
        }

        $subNav.removeClass(navClassModifier('hidden'));
    }

    toggleClass(true);
    addAction(LAYOUT, toggleClass);
});
